import React from "react";

import { ColorType, Tag, Text } from "@ifgengineering/component-library";
import { TextContainer } from "./styled";
import SimpleTooltip from "@components/SimpleTooltip";
import { Label } from "@ifgengineering/client-invest-sdk";

const sortLabels = (labels: Label[]): Label[] =>
  labels.sort((a, b) => {
    if (a.priority === b.priority) {
      return 0;
    }

    if (!a.priority) {
      return 1;
    }

    if (!b.priority) {
      return -1;
    }
    return a.priority - b.priority;
  });

export const getLabelsWithValues = (labels: Label[]): Label[] =>
  sortLabels(labels.filter(({ bgColor }) => !bgColor));

const renderLabels = (labels: Label[], isExpiredDeal: boolean) => {
  const labelsWithValues = getLabelsWithValues(labels);

  if (!labelsWithValues.length) {
    return null;
  }

  return labelsWithValues.map((label) => {
    return (
      <TextContainer
        key={label.id}
        background={isExpiredDeal ? "SLATE200" : "SLATE100"}
      >
        <Text type="P16" color="SLATE600">
          {label.name}
        </Text>
        {label.description && <SimpleTooltip text={label.description} />}
        <Text type="H18" color={isExpiredDeal ? "SLATE700" : "SLATE800"}>
          {label.value}
        </Text>
      </TextContainer>
    );
  });
};

const renderTags = (labels: Label[]) => {
  const tags = sortLabels(labels.filter(({ bgColor }) => bgColor));
  if (!tags.length) {
    return null;
  }

  return tags.map((tag) => {
    return (
      <Tag
        key={tag.id}
        backgroundColor={tag.bgColor as ColorType | "WHITE"}
        color={tag.textColor as ColorType | "BLACK"}
        text={tag.name}
        size="small"
        testId="dynamic-tag"
      />
    );
  });
};

type renderDealLabelsReturn = {
  labels: JSX.Element[] | null;
  tags: JSX.Element[] | null;
};

const renderDealLabels = (
  labels: Label[],
  options = { isExpiredDeal: false }
): renderDealLabelsReturn => {
  const { isExpiredDeal } = options;
  return {
    labels: renderLabels(labels, isExpiredDeal),
    tags: renderTags(labels),
  };
};

export interface DealLabels {
  labels: JSX.Element[] | null;
  tags: JSX.Element[] | null;
}

export default renderDealLabels;
